import { render, staticRenderFns } from "./VideoJs.vue?vue&type=template&id=0a61e55e"
import script from "./VideoJs.vue?vue&type=script&lang=js"
export * from "./VideoJs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports